import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import SellTestStrips from "@/pages/seo/SellTestStrips";
import WhoBuysNearMe from "@/pages/seo/WhoBuysNearMe";
import AcceptedSupplies from "@/pages/seo/AcceptedSupplies";
import SellMedtronic from "@/pages/seo/SellMedtronic";
import TestStripsWorth from "@/pages/seo/TestStripsWorth";
import JacksonvilleService from "@/pages/seo/JacksonvilleService";
import WhereToSell from "@/pages/seo/WhereToSell";
import HowToSell from "@/pages/seo/HowToSell";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/sell-diabetic-test-strips" element={<SellTestStrips />} />
          <Route path="/sell-diabetic-test-strips/" element={<SellTestStrips />} />
          <Route path="/who-buys-diabetic-supplies-near-me" element={<WhoBuysNearMe />} />
          <Route path="/who-buys-diabetic-supplies-near-me/" element={<WhoBuysNearMe />} />
          <Route path="/accepted-diabetic-supplies" element={<AcceptedSupplies />} />
          <Route path="/accepted-diabetic-supplies/" element={<AcceptedSupplies />} />
          <Route path="/sell-medtronic-supplies" element={<SellMedtronic />} />
          <Route path="/sell-medtronic-supplies/" element={<SellMedtronic />} />
          <Route path="/how-much-are-diabetic-test-strips-worth" element={<TestStripsWorth />} />
          <Route path="/how-much-are-diabetic-test-strips-worth/" element={<TestStripsWorth />} />
          <Route path="/sell-diabetic-supplies-jacksonville-fl" element={<JacksonvilleService />} />
          <Route path="/sell-diabetic-supplies-jacksonville-fl/" element={<JacksonvilleService />} />
          <Route path="/where-to-sell-diabetic-test-strips" element={<WhereToSell />} />
          <Route path="/where-to-sell-diabetic-test-strips/" element={<WhereToSell />} />
          <Route path="/how-to-sell-unused-diabetic-test-strips" element={<HowToSell />} />
          <Route path="/how-to-sell-unused-diabetic-test-strips/" element={<HowToSell />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
